<script lang="ts" setup></script>

<template>
  <div class="badge">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.badge {
  color: #fff;

  padding: 10px 16px;
  background: linear-gradient(93.61deg, #ff372e 16.25%, #ffbb46 118.84%);
  border-radius: 20px;

  &.blue {
    background: var(--color-accent);
  }

  &.red {
    background: var(--color-error);
  }
}
</style>
